/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';

import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../shared/services/error.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentService } from '../../shared/services/payment.service';

import { StorageEnum } from '../../shared/enums/storage.enum';
import { AccountDetail } from '../../shared/models/account-detail';

import { type UserProfile } from '../../shared/models/user-profile';
import { Nav } from '../../shared/enums/nav.enum';
import { catchError, concatMap, EMPTY, type Observable, of } from 'rxjs';
import { AutoPayCancel } from '../../shared/models/autopay-cancel';
import { PaymentAccountType } from '../../shared/enums/paymentaccounttype.enum';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrl: './delete-account.component.scss',
  imports: [MatDividerModule, MatButtonModule, PageHeaderComponent, RouterModule],
})
export class DeleteAccountComponent implements OnInit {
  pageReady = false;
  accountDetail: AccountDetail = new AccountDetail();
  userProfile?: UserProfile;
  pageLabels: any = {};
  isBrowser = false;
  headerData = new PageHeader();

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly utils: UtilService,
    private readonly storage: StorageService,
    private readonly account: AccountService,
    private readonly cms: CmsService,
    private readonly router: Router,
    private readonly error: ErrorService,
    private readonly payment: PaymentService,
    private readonly seoS: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
      this.userProfile = this.storage.getSession(StorageEnum.LoginResponse);
    }
  }

  ngOnInit(): void {
    this.cms.getContent('oas-delete-account', 'Delete Account Labels').subscribe((data) => {
      this.pageLabels = data;
      this.headerData.Message = this.pageLabels.deleteAccountHeaderText;
      this.seoS.setSeoTags(data.seo);
      this.pageReady = true;
      this.utils.hideSpinner();
    });
  }

  deleteUserName(): void {
    this.utils.showSpinner();
    const accountNumber = this.accountDetail?.AccountNumber;
    const userName = this.userProfile?.UserName!;
    const onAutoPay = this.accountDetail.IsAutoPay;
    const hasFuturePayment =
      this.accountDetail.FuturePayment !== undefined && this.accountDetail.FuturePayment !== null;
    const futurePayment = this.payment.buildCancelFutureDatePaymentRequest(this.accountDetail);
    if (onAutoPay) {
      this.cancelAutoPay()
        .pipe(
          catchError((e) => {
            this.error.setErrorData('none', this.pageLabels.deleteAccountErrorDetails);
            void this.router.navigateByUrl(Nav.ErrorPage);
            return EMPTY;
          }),
          concatMap(() => {
            if (hasFuturePayment) {
              return this.payment.postFuturePayment(futurePayment);
            } else {
              return of('success');
            }
          }),
          concatMap(() => {
            return this.account.DeleteOASAccount(accountNumber, userName);
          }),
        )
        .subscribe({
          error: () => {
            this.error.setErrorData('none', this.pageLabels.deleteAccountErrorDetails);
            void this.router.navigateByUrl(Nav.ErrorPage);
          },
          next: () => {
            void this.router.navigateByUrl(Nav.Login + '?accountDeleted=true');
          },
        });
    }
    if (!onAutoPay && hasFuturePayment) {
      this.payment
        .postFuturePayment(futurePayment)
        .pipe(
          concatMap(() => {
            return this.account.DeleteOASAccount(accountNumber, userName);
          }),
        )
        .subscribe({
          error: () => {
            this.error.setErrorData('none', this.pageLabels.deleteAccountErrorDetails);
            void this.router.navigateByUrl(Nav.ErrorPage);
          },
          next: () => {
            void this.router.navigateByUrl(Nav.Login + '?accountDeleted=true');
          },
        });
    }
    if (!onAutoPay && !hasFuturePayment) {
      this.account.DeleteOASAccount(accountNumber, userName).subscribe({
        error: () => {
          this.error.setErrorData('none', this.pageLabels.deleteAccountErrorDetails);
          void this.router.navigateByUrl(Nav.ErrorPage);
        },
        next: () => {
          void this.router.navigateByUrl(Nav.Login + '?accountDeleted=true');
        },
      });
    }
  }

  cancelAutoPay(): Observable<any> {
    this.utils.showSpinner();
    const autoPayCancelRequest = new AutoPayCancel();
    autoPayCancelRequest.AccountNumber = this.accountDetail.AccountNumber;
    autoPayCancelRequest.RecurringScheduleId = this.accountDetail.AutoPay?.RecurringScheduleId;
    autoPayCancelRequest.CustomerClass = this.accountDetail.CustomerClass;

    if (this.accountDetail.AutoPay?.PaymentAccountType === PaymentAccountType.Banking) {
      return this.payment.cancelAutoPayBank(autoPayCancelRequest);
    } else {
      return this.payment.cancelAutoPayCard(autoPayCancelRequest);
    }
  }
}
